import React, { useMemo } from 'react';
import T from 'prop-types';
import { times } from 'lodash-es';

import Modal from '../../../../../components/Modal';
import Skeleton from '../../../../../components/Skeleton';
import { SortableTable } from '../../../../../components/SortableTable';
import { numberToBytes } from '../../../../../utils/bytes';

const columns = [
  {
    dataField: 'time_period',
    text: 'Time Period',
  },
  {
    dataField: 'date',
    text: 'Date',
  },
  {
    dataField: 'downloaded_at',
    text: 'Downloaded',
  },
  {
    dataField: 'version_size',
    text: 'Size',
  },
  {
    dataField: 'actions',
    text: '',
  },
];

const skeletonRows = times(8, (n) => ({
  key: n,
  name: <Skeleton height={16} width="60%" />,
  frequency: <Skeleton height={16} width="80%" />,
  time_period: <Skeleton height={16} />,
  updated_at: <Skeleton height={16} width="70%" />,
  downloaded_at: <Skeleton height={16} width="70%" />,
  version_size: <Skeleton height={16} width="70%" />,
  actions: (
    <div className="exports-actions-buttons">
      <Skeleton height={32} width={32} />
    </div>
  ),
}));

const VersionsHistoryModal = ({ pending = true, versionHistory, open, report, handleClose }) => {
  const handleDownload = (e, version) => {
    e.preventDefault();
    window.location.replace(window.location.origin + version.download_link);
  };

  const rows = useMemo(
    () =>
      versionHistory.history
        ? versionHistory.history.map((version) => ({
            time_period: version.time_period,
            date: version.date,
            downloaded_at: version.downloaded_at,
            version_size: numberToBytes(version.version_size),
            actions: (
              <div
                className="b-a-0 p-a-0 cursor-pointer"
                onClick={(e) => handleDownload(e, version)}
              >
                <i className="hicon-download-thin text-16" />
              </div>
            ),
          }))
        : [],
    [versionHistory]
  );

  return (
    <Modal
      open={open}
      closeButtonVersionButton
      modalClassName="version-history-modal"
      onClose={handleClose}
    >
      <div>
        <div className="version-history-modal-header">
          <h1 className="version-history-modal-header-title text-18">{report.name}</h1>
        </div>
        <div className="version-history-modal-body">
          <SortableTable
            tableClassName="table-default version-history-modal-table div-grid-table"
            style={{ tableLayout: 'fixed' }}
            columns={columns}
            rows={pending ? skeletonRows : rows}
          />
          {versionHistory.has_expired_versions && (
            <div className="version-history-modal-footer">
              <h2 className="version-history-modal-footer-text">
                Older reports no longer available
              </h2>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

VersionsHistoryModal.propTypes = {
  pending: T.bool,
  versionHistory: T.object,
  open: T.bool,
  handleClose: T.func,
  report: T.object,
};

export default VersionsHistoryModal;
